import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBtc = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#btc_svg__a)'>
      <path fill='#F7931A' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='#fff'
        d='M17.292 10.29c.238-1.597-.977-2.455-2.64-3.028l.54-2.163-1.317-.328-.525 2.106a55 55 0 0 0-1.056-.248l.53-2.12-1.317-.328-.54 2.162a43 43 0 0 1-.84-.197l.002-.007-1.816-.454-.35 1.407s.976.224.956.237c.533.134.63.487.613.766l-.614 2.465q.056.012.137.044l-.14-.035-.86 3.452c-.066.162-.231.406-.604.313.013.02-.957-.239-.957-.239l-.654 1.508 1.714.427q.478.122.939.242l-.545 2.188 1.315.328.54-2.165q.538.146 1.05.273l-.539 2.154 1.317.328.545-2.183c2.246.425 3.934.253 4.644-1.778.573-1.635-.028-2.578-1.21-3.193.861-.199 1.509-.765 1.681-1.934m-3.01 4.22c-.406 1.634-3.16.75-4.052.529l.723-2.899c.893.223 3.755.664 3.33 2.37m.408-4.243c-.371 1.487-2.662.731-3.406.546l.656-2.629c.743.185 3.137.531 2.75 2.083'
      />
    </g>
    <defs>
      <clipPath id='btc_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgBtc)
export default ForwardRef
